import React from 'react'

function Privacy() {
    return (
        <div className='py-14 md:px-60 px-5 text-left font-semibold'>
            <h1 className='text-4xl font-bold text-black py-4'>Privacy Policy</h1>
            <p className='py-4'> Lorem ipsum dolor sit amet, consectetur dipiscingelit. Vestibulum vitae nunc vitae neque.</p>
            <p className='py-4'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut ut nulla eu lorem rutrum tempus. Integer tincidunt tellus quis est tincidunt auctor.</p>
            <h2 className='text-2xl text-black py-4 font-bold'>Phasellus scelerisque eros felis</h2>
            <p className='py-2'>
                Put lobortis ipsum mattis ullamcorper. Morbi magna orci, ornare vel auctor non, malesuada sed dolor.
                Pellentesque facilisis condimentum nunc, nec placerat eros aliquam lobortis. Nullam non bibendum neque,
                nec sagittis risus. Proin est metus, bibendum at maximus quis, placerat id sapien. Fusce ipsum quam, placerat
                sit amet mauris vitae, suscipit ultrices turpis. Etiam ac eros est. Quisque id rhoncus dolor, eget gravida ante.
                Integer commodo id lacus at fringilla.
            </p>
            <p className='py-2'>
                Phasellus scelerisque eros felis, ut lobortis ipsum mattis ullamcorper. Morbi magna orci, ornare vel auctor non,
                malesuada sed dolor. Pellentesque facilisis condimentum nunc, nec placerat eros aliquam lobortis. Nullam non
                bibendum neque, nec sagittis risus. Proin est metus, bibendum at maximus quis, placerat id sapien. Fusce ipsum
                quam, placerat sit amet mauris vitae, suscipit ultrices turpis. Etiam ac eros est. Quisque id rhoncus dolor,
                eget gravida ante. Integer commodo id lacus at fringilla.
            </p>
            <h2 className='text-2xl text-black py-4 font-bold'>Lorem ipsum dolor sit amet</h2>
            <p>
                Phasellus scelerisque eros felis, ut lobortis ipsum mattis ullamcorper. Morbi magna orci, ornare vel auctor non,
                malesuada sed dolor. Pellentesque facilisis condimentum nunc, nec placerat eros aliquam lobortis. Nullam non
                bibendum neque, nec sagittis risus. Proin est metus, bibendum at maximus quis, placerat id sapien. Fusce ipsum
                quam, placerat sit amet mauris vitae, suscipit ultrices turpis. Etiam ac eros est. Quisque id rhoncus dolor,
                eget gravida ante. Integer commodo id lacus at fringilla.
            </p>
            <h2 className='text-xl text-black py-4 font-bold'>Phasellus scelerisque eros felis</h2>
            <p>
                Put lobortis ipsum mattis ullamcorper. Morbi magna orci, ornare vel auctor non, malesuada sed dolor. Pellentesque
                facilisis condimentum nunc, nec placerat eros aliquam lobortis. Nullam non bibendum neque, nec sagittis risus.
                Proin est metus, bibendum at maximus quis, placerat id sapien. Fusce ipsum quam, placerat sit amet mauris vitae,
                suscipit ultrices turpis. Etiam ac eros est. Quisque id rhoncus dolor, eget gravida ante. Integer commodo id lacus
                at fringilla.Phasellus scelerisque eros felis, ut lobortis ipsum mattis ullamcorper. Morbi magna orci, ornare vel
                auctor non, malesuada sed dolor. Pellentesque facilisis condimentum nunc, nec placerat eros aliquam lobortis.
                Nullam non bibendum neque, nec sagittis risus. Proin est metus, bibendum at maximus quis, placerat id sapien.
                Fusce ipsum quam, placerat sit amet mauris vitae, suscipit ultrices turpis. Etiam ac eros est. Quisque id rhoncus
                dolor, eget gravida ante. Integer commodo id lacus at fringilla.
            </p>

        </div>
    )
}
export default Privacy